// extracted by mini-css-extract-plugin
export default {"imgBox":"index_imgBox_9aH-I","innerBox":"index_innerBox_UvDaW"};